import { useEffect } from "react";
import InspirationComponent from "@/components/Inspiration";
import Searchbar from "@/components/Searchbar";
import Prefooter from "@/components/Prefooter";
import triggerAnalyticsEvent, { dispatchMKPLCustomEvent } from "@/helpers/triggerAnalyticsEvent";


const HomePage = ({onSearchSubmit = () => {}} : {onSearchSubmit?: (query: boolean) => void;}) => {
 
  useEffect(() => {
    triggerAnalyticsEvent({
      PageName: "landingpage",
      pageFunction: "searchinspiration",
      ABTestname: "",
      domainidentifier: "Joyhunt",
    });
    if(_SFDDL != undefined && _SFDDL.pageInfo != undefined && _SFDDL.pageInfo.hasOwnProperty("ErrorMessage")) {
      delete _SFDDL.pageInfo.ErrorMessage;
    }
    if(_SFDDL != undefined && _SFDDL.pageInfo != undefined && _SFDDL.pageInfo.hasOwnProperty("MessageType")) {
      delete _SFDDL.pageInfo.MessageType;
    }
    if(_SFDDL != undefined && _SFDDL.pageInfo != undefined && _SFDDL.pageInfo.hasOwnProperty("RelyingParty")) {
      delete _SFDDL.pageInfo.RelyingParty;
    }
    if(_SFDDL != undefined && _SFDDL.pageInfo != undefined && _SFDDL.pageInfo.hasOwnProperty("pageName")) {
      delete _SFDDL.pageInfo.pageName;
    }
    dispatchMKPLCustomEvent();

  }, []);

  return (
    <div className="flex flex-col items-center w-full">
     
      <main className="min-w-[375px] w-full bg-charcoal">
        <div
        style = {{backgroundImage: `linear-gradient(77.9deg, rgba(0, 0, 0, 0.8) 1.58%, rgba(0, 0, 0, 0) 93.61%),url(${bannerDetails.src})`}}
          className={`JH-HM-BG bg-no-repeat bg-top bg-[length:160%_60%] xs:bg-cover w-full xs:h-[429px] md:h-[816px] pt-[24px] md:pt-[120px] max-w-[1800px] mx-auto`}>
          <div className="max-w-[1440px] mx-auto text-white">
            <div className="ml-[48px] w-[226px] sm:w-[388px] md:w-[670px] h-[116px]">
              <h1 className="text-[36px] md:text-[64px] font-bold leading-[40px] md:leading-[64px]">
               {bannerDetails.bannerHeading}
              </h1>
              <div className="relative">
                <h1 className="text-[36px] md:text-[64px] font-bold leading-[40px] md:leading-[64px]">
                {bannerDetails.bannerSubheading}
                </h1>
              
              </div>
              <span className="hidden md:inline mt-[24px] font-semibold text-[24px] leading-[32px]">
              {bannerDetails.bannerDescription}
              </span>
              <br />
              <span className="hidden md:inline font-semibold text-[24px] leading-[32px]">
              {bannerDetails.bannerAdditionalDescription}
              </span>
            </div>
            <div className="w-full flex flex-col items-left h-[178px] sm:h-[126px] bg-charcoal md:bg-transparent mt-24 sm:mt-36 px-[8px] pt-[16px]">
              <div className="w-full flex flex-col sm:flex-row">
                <span
                  className="sm:inline md:hidden text-[14px] font-semibold leading-[20px] ml-[37px] xs:ml-[32px] mb-2"
                  id="search-description"
                >
                 {bannerDetails.bannerDescription} {" "} {bannerDetails.bannerAdditionalDescription}
                </span>
              </div>
              <div className="px-[16px] sm:px-[40px]">
                <Searchbar showBeta showSamples onSearchSubmit={onSearchSubmit}/>
              </div>
            </div>
          </div>
        </div>
        <InspirationComponent onSearchSubmit={onSearchSubmit}/>
        <Prefooter showTradeMarkDisclaimer />
      </main>
    </div>
  );
};

export default HomePage;
